
import api from "../../../../api/api"

const typeIcons = {1: '📝',2: '⏰',3: '🗓️'};
const priorityDots = {1 :'🚨', 2 : '🟡', 3 : '🟢'}; //🔴

const statusColorClass = {
    1:"bg-charcoal",
    2:"bg-warning",
    3:"bg-orange",
    4:"bg-plum",
    5:"bg-magenta",
    6:"bg-success"
}


const statusBorderColorClass = {
    1:"border-charcoal",
    2:"border-warning",
    3:"border-orange",
    4:"border-purple",
    5:"border-magenta",
    6:"border-success"
}

const statusTableColorClass = {
    1:"table-charcoal",
    2:"table-warning",
    3:"table-orange",
    4:"table-plum",
    5:"table-magenta",
    6:"table-success"
}

const getList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/task").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getArchivedList = () =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/task/archived/list").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getDD = () =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/dd/task").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getById = (id) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/task/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getByProjectId = (id) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/task/project/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const save = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/task",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const update = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("erp/task/update",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const remove = (id) => {
    return new Promise((resolve, reject)=>{
        api.delete("erp/task/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const restore = (id) => {
    return new Promise((resolve, reject)=>{
        api.delete("erp/task/restore/"+id).then( (res)=>{
            if(!res.data.error){
                resolve(res);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const taskServices = {
    typeIcons,
    priorityDots,
    statusColorClass,
    statusBorderColorClass,
    statusTableColorClass,
    getList,
    getArchivedList,
    getDD,
    getById,
    getByProjectId,
    save,
    update,
    remove,
    restore
}
export default taskServices;